import { shareContent } from '../../../utils/shareUtils';

// Hook để handle share
export const useHeaderShare = (title?: string) => {
  const handleShare = async () => {
    try {
      await shareContent({
        title: title
      });
    } catch (error) {
      console.error('Share failed:', error);
    }
  };

  return { handleShare };
};
